<div class="standard-card-container-for-user-account" [ngClass]="{'standard-card-container-active': (subscriptionPlanInfoModel.isStandard && !isFromUserPage),
 'disabled': checkIfActiveSubscriptionPlan(), 'payment-missing': isDisabledByMissingPayment, 'standard-card-container' : !isFromUserPage}">
  <div [ngClass]="{'standard-card-for-user-account': isFromUserPage, 'standard-card': !isFromUserPage}">
    <div [ngClass]="{'first-standard-card-layout': !isFromUserPage}">
      <div class="standard-card-icon-and-text-container">
        <div
          [ngClass]="{'standard-card-icon-container-active': subscriptionPlanInfoModel.isStandard, 'standard-card-icon-container': !subscriptionPlanInfoModel.isStandard,
           'standard-card-icon-container-for-user-page': isFromUserPage}">
          <img
            [src]="subscriptionPlanInfoModel.isStandard ? '/assets/subscription-plan/icon-standard.svg' : (subscriptionPlanInfoModel.isStarter ? '/assets/subscription-plan/icon-starter.svg' : '/assets/subscription-plan/icon-premium.svg')"
            class="standard-icon"
            [ngStyle]="{'transform': !subscriptionPlanInfoModel.isIndividuals && subscriptionPlanInfoModel.isStarter ? 'rotate(-45deg)' : (!subscriptionPlanInfoModel.isIndividuals ? 'rotate(-90deg)' : 'rotate(0deg)')}"
            alt="icon">
        </div>
        <div class="standard-text" [attr.lang]="currentLang">
          {{ getTranslatedSubscriptionTitle(subscriptionPlanInfoModel.subscriptionPlanData.subscriptionType) }}
        </div>
      </div>
      <br>
      <div class="standard-under-text">
        {{ getDescription() | translate }}
      </div>
      <br>
      <div class="standard-card-cost-container mt-4">
        <div
          [ngClass]="{'standard-card-cost-active' : subscriptionPlanInfoModel.isStandard, 'standard-card-cost' : !subscriptionPlanInfoModel.isStandard,  'standard-card-cost-ru': currentLang === Language.RU, 'standard-card-cost-am': currentLang === Language.HY }">
          @if (subscriptionPlanInfoModel.isYearly) {
            @if (subscriptionPlanInfoModel.subscriptionPlanData.price === 0) {
              {{ FREE | translate }}
            } @else {
              ${{ (subscriptionPlanInfoModel.subscriptionPlanData.price * 10) }}
            }
            <span class="subscribe-duration">
                /{{ YEARLY | translate }}
            </span>
          } @else {
            @if (subscriptionPlanInfoModel.subscriptionPlanData.price === 0) {
              {{ FREE | translate }}
            } @else {
              ${{ subscriptionPlanInfoModel.subscriptionPlanData.price }}
            }

            <span class="subscribe-duration xxx">
                /{{ MONTHLY | translate }}
            </span>
          }
        </div>
        @if (currentLang === Language.HY && subscriptionPlanInfoModel.subscriptionPlanData.price !== 0) {
          <div class="subscribe-duration-wrapper">
            <div class="amd-subscribe">
              @if (subscriptionPlanInfoModel.isYearly) {
                {{ (subscriptionPlanInfoModel.subscriptionPlanData.price * 10 * DOLLAR_TO_DRAM_CURRENCY) | number:'1.0-0' }} {{ AMD | translate }}
              } @else {
                {{ (subscriptionPlanInfoModel.subscriptionPlanData.price * DOLLAR_TO_DRAM_CURRENCY) | number:'1.0-0' }} {{ AMD | translate }}
              }
            </div>
          </div>
        }
      </div>
      <br>
      <div class="subscription-plan-include-container"  [ngClass]="{'subscription-plan-include-container-for-user-account': isFromUserPage}">
        <div class="subscription-plan-include-text mt-3" [attr.lang]="currentLang">
          {{ 'subscription_plan_content.whats_included' | translate }}
        </div>
        <div class="subscription-plan-included">
          <div class="plan-include-container">
            <div class="plan-include-icon">
              <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon" class="new-img">
            </div>
            <div class="plan-include-text" [attr.lang]="currentLang">
              @if (subscriptionPlanInfoModel.subscriptionPlanData.parent.accountType === AccountType.INDIVIDUAL) {
                @if (subscriptionPlanInfoModel.subscriptionPlanData.cardCount > 1) {
                  {{ subscriptionPlanInfoModel.subscriptionPlanData.cardCount }} {{ 'subscription_plan_content.free_cards' | translate }}
                } @else {
                  {{ subscriptionPlanInfoModel.subscriptionPlanData.cardCount }} {{ 'subscription_plan_content.free_card' | translate }}
                }
              } @else if (subscriptionPlanInfoModel.subscriptionPlanData.parent.accountType === AccountType.TEAM) {
                {{ 'subscription_plan_content.up_to' | translate }} {{ subscriptionPlanInfoModel.subscriptionPlanData.cardCount }} {{ 'subscription_plan_content.member_cards' | translate }}
              }
            </div>
          </div>
          @if (subscriptionPlanInfoModel.subscriptionPlanData.parent.accountType === AccountType.TEAM) {
            <div class="plan-include-container">
              <div class="plan-include-icon">
                <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon" class="new-img">
              </div>
              <div class="plan-include-text" [attr.lang]="currentLang">
                @if (subscriptionPlanInfoModel.isYearly) {
                  {{ 'subscription_plan_content.next_card_price_is' | translate }} {{ subscriptionPlanInfoModel.subscriptionPlanData.nextCardPrice * 10 }}$
                  @if (currentLang === Language.HY) {
                    / {{ (subscriptionPlanInfoModel.subscriptionPlanData.nextCardPrice * 10 * DOLLAR_TO_DRAM_CURRENCY) | number:'1.0-0' }} {{ AMD | translate }}
                  }
                } @else {
                  {{ 'subscription_plan_content.next_card_price_is' | translate }} {{ subscriptionPlanInfoModel.subscriptionPlanData.nextCardPrice }}$
                  @if (currentLang === Language.HY) {
                    / {{ (subscriptionPlanInfoModel.subscriptionPlanData.nextCardPrice * DOLLAR_TO_DRAM_CURRENCY) | number:'1.0-0' }} {{ AMD | translate }}
                  }
                }
              </div>
            </div>
            @if (isFromUserPage) {
              <div class="plan-include-container">
                <div class="plan-include-icon">
                  <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon" class="new-img">
                </div>
                <div class="plan-include-text" [attr.lang]="currentLang">
                  @if (subscriptionPlanInfoModel.subscriptionPlanData.title == SharedConstants.BASIC) {
                    {{ 'subscription_plan_content.next_card_limit_40' | translate }}
                  } @else if (subscriptionPlanInfoModel.subscriptionPlanData.title == SharedConstants.PROFESSIONAL) {
                    {{ 'subscription_plan_content.next_card_limit_100' | translate }}
                  } @else {
                    {{ 'subscription_plan_content.unlimited_next_cards' | translate }}
                  }
                </div>
              </div>
            }
          }
          <div class="plan-include-container">
            <div class="plan-include-icon">
              <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon" class="new-img">
            </div>
            <div class="plan-include-text" [attr.lang]="currentLang">
              @if (subscriptionPlanInfoModel.subscriptionPlanData?.linkCount === null) {
                {{ 'subscription_plan_content.unlimited_links' | translate }}
              } @else {
                {{ 'subscription_plan_content.up_to' | translate }} {{ subscriptionPlanInfoModel.subscriptionPlanData?.linkCount }} {{ 'subscription_plan_content.links' | translate }}
              }
            </div>
          </div>
          @if (subscriptionPlanInfoModel.subscriptionPlanData.subscriptionType !== SubscriptionType.STARTER) {
            <div class="plan-include-container">
              <div class="plan-include-icon">
                <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon" class="new-img">
              </div>
              <div class="plan-include-text" [attr.lang]="currentLang">
                @if (subscriptionPlanInfoModel.subscriptionPlanData?.paymentMethodCount === null) {
                  {{ 'subscription_plan_content.all_payment_methods' | translate }}
                } @else {
                  {{ subscriptionPlanInfoModel.subscriptionPlanData?.paymentMethodCount }} {{ 'subscription_plan_content.payment_method' | translate }}
                }
              </div>
            </div>
          }
          @if (subscriptionPlanInfoModel.subscriptionPlanData.subscriptionType === SubscriptionType.PREMIUM &&
               subscriptionPlanInfoModel.subscriptionPlanData.parent.accountType === AccountType.INDIVIDUAL) {
            <div class="plan-include-container">
              <div class="plan-include-icon">
                <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon" class="new-img">
              </div>
              <div class="plan-include-text" [attr.lang]="currentLang">
                {{ 'subscription_plan_content.menu_management' | translate }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (isAuthenticated && subscriptionPlanInfoModel.subscriptionPlanData.subscriptionType == SubscriptionType.STARTER) {
    <button class="tall-button mobile-button empty-button d-flex justify-content-center"
            [disabled]="true"
            [ngClass]="{'mt-90px' : subscriptionPlanInfoModel.isIndividuals, 'mt-140px': !subscriptionPlanInfoModel.isIndividuals}">
    </button>
  } @else {
    <button class="filled-button tall-button mobile-button d-flex justify-content-center"
            [disabled]="isCardDisabled()"
            (click)="!isCardDisabled() && payOrLogin(subscriptionPlanInfoModel.subscriptionPlanData.parent.accountType)"
            [ngClass]="{'mt-120px' : subscriptionPlanInfoModel.isIndividuals, 'mt-140px': !subscriptionPlanInfoModel.isIndividuals}">
      {{ 'subscription_plan_content.get_started' | translate }}
    </button>
  }
</div>
